__webpack_require__.p = "https://app.takestock360.com/";